<template>
  <div>
    <h1>Single Sales Report full details, all deduction, cheque's status and history </h1>
  </div>
</template>
    
<script setup>

</script>